import SEO from "@/components/SEO";
import Hero from "@/sections/Hero";
import HowItWorks from "@/sections/HowItWorks";
import CoreServices from "@/sections/CoreServices";
import WhoWeServe from "@/sections/WhoWeServe";
import ServiceAreasPreview from "@/sections/ServiceAreasPreview";
import HomeContact from "@/sections/HomeContact";
import { COMPANY } from "@/data/content";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: COMPANY.name,
    alternateName: "IEG",
    url: `https://${COMPANY.domain}`,
    email: COMPANY.email,
    description: COMPANY.positioning,
    areaServed: "United States",
    knowsAbout: [
      "Commercial electricity procurement",
      "Commercial natural gas procurement",
      "Energy broker",
      "Virtual Power Plant Network (distributed battery energy storage hosting)",
      "Energy market advisory",
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: COMPANY.name,
    url: `https://${COMPANY.domain}`,
  },
];

export default function Home() {
  return (
    <>
      <SEO
        title=""
        description="Innervation Energy Group is a commercial energy brokerage. We represent your business — comparing electricity and natural gas suppliers, negotiating competitive contract terms, and connecting you with the best commercial energy solution."
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <CoreServices />
      <WhoWeServe />
      <ServiceAreasPreview />
      <HowItWorks />
      <HomeContact />
    </>
  );
}
